export default __webpack_public_path__ + "static/media/40173.46402c21.jpg";